const $ = window.jQuery;
const bootbox = window.bootbox;
const doT = window.doT;
const svg4everybody = window.svg4everybody;

// only permit valid URL date strings
export const checkUrlDate = (val) => {
  const refPattern = /^(\d+)\/0*(\d+)\/0*(\d+)\/?$/;
  if (refPattern.test(val)) {
    return val.match(refPattern)[0];
  }
  return null;
};

// only permit valid port numbers, defaulting to 443
export const checkPortNum = (val) => {
  const refPattern = /[0-9]+/;
  if (refPattern.test(String(val))) {
    return String(val).match(refPattern)[0];
  }
  return '443';
};

// only permit valid reference strings
export const checkReference = (val) => {
  const refPattern = /[A-Za-z0-9_-]+/;
  if (refPattern.test(val)) {
    return val.match(refPattern)[0];
  }
  return null;
};

export const loadJsonFromScript = (id) => {
  return JSON.parse(document.getElementById(id).textContent);
};

/**
 * A tagged template which will URL encode all values passed
 *
 * Example:
 * >> urlTempl`foo/bar/${'some&bad"stuff'}/qux`
 * <- "foo/bar/some%26bad%22stuff/qux"
 */
export const urlTempl = (parts, ...values) => {
  let sum = '';
  const zipped = parts.map((elem, ind) => [elem, values[ind]]);
  for (const [part, value] of zipped) {
    if (value) {
      sum += `${part}${encodeURIComponent(value)}`;
    } else {
      sum += part;
    }
  }
  return sum;
};

const entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;',
  '/': '&#x2F;',
};

export const escapeHTML = (string) =>
  String(string).replace(/[&<>"'`/]/g, (s) => entityMap[s]);

/**
 * A tagged template which will HTML escape all values passed
 *
 * Example:
 * >> html`<a href="${'"/><script></script>'}">link</a>`
 * <- "<a href=\"&quot;&#x2F;&gt;&lt;script&gt;&lt;&#x2F;script&gt;\">link</a>"
 */
export const html = (parts, ...values) => {
  let sum = '';
  const zipped = parts.map((elem, ind) => [elem, values[ind]]);
  for (let [part, value] of zipped) {
    if (value) {
      // If the value expression is preceded by a dollar sign,
      // don't escape the value
      if (part.endsWith('$')) {
        part = part.slice(0, -1);
        sum += `${part}${value}`;
      } else {
        sum += `${part}${escapeHTML(value)}`;
      }
    } else {
      sum += part;
    }
  }
  return sum;
};

let templates;

if (!$.uncamelCase) {
  // Convert camelCase to dashed
  $.uncamelCase = (string) =>
    string
      .replace(/([A-Z])/g, '-$1')
      .toLowerCase()
      .replace(/^-/, '');
}

// JQuery plugin to set data attribute
// See: http://blog.rodneyrehm.de/archives/3-Making-jQuery.data-selector-aware.html
$.fn.dataAttr = function (key, value) {
  const ret = this.data(key, value);
  const data = (v) => (typeof v) in { string: 1, number: 1 };
  if (typeof key === 'object') {
    $.each(key, (key, value) => {
      this.attr(`data-${$.uncamelCase(key)}`, data(value) ? value : 1);
    });
  } else if (value !== undefined) {
    this.attr(`data-${key}`, data(value) ? value : 1);
  }
  return ret;
};

/**
 * Load doT templates, where spec is an object of template DOM ids mapped to
 * template names.  Returns an object of template functions corresponding to
 * the ids, mapped to template names.
 */
export const loadTemplates = (spec) => {
  const templates = {};
  for (const name in spec) {
    if (Object.hasOwn(spec, name)) {
      const templateStr = document.getElementById(spec[name]).text;
      templates[name] = doT.template(templateStr);
    }
  }
  return templates;
};

/**
 * Use custom confirm box for Rails data-confirm USJ
 */
function customConfirmBox(message, callback) {
  bootbox.confirm({
    message: message,
    callback: callback,
  });
}

/*
   * does not appear to be used.
  function active_class(a) {
    let items = document.querySelectorAll('.menu_bar.active');
    if (items.length) {
      items[0].className = 'menu_bar';
    }
    a.className = 'menu_bar active';
  }
  */

$.rails.allowAction = (element) => {
  const message = element.data('confirm');
  if (!message) {
    return true;
  }

  if ($.rails.fire(element, 'confirm')) {
    customConfirmBox(message, (answer) => {
      const callback = $.rails.fire(element, 'confirm:complete', [answer]);
      if (answer && callback) {
        const oldAllowAction = $.rails.allowAction;
        $.rails.allowAction = () => true;
        element.trigger('click');
        $.rails.allowAction = oldAllowAction;
      }
    });
  }
  return false;
};

/**
 * Enable bootstrap tooltips where needed
 */
$('[data-toggle="tooltip"]').tooltip();

/**
 * Add the ability to specify the focus element in a modal dialogue using the
 * data-modal-focus attribute of the modal div
 */
$('[data-modal-focus]').on('shown.bs.modal', function () {
  const $modal = $(this);
  $modal.find($modal.data('modal-focus')).focus();
});

window.lang = $('html').prop('lang');
window.locale = $('meta[name="locale"]').prop('content');
window.userName = $('meta[name="user"]').prop('content');

$(document).click(() => {
  $('#user-profile-drop-down').css({ visibility: 'hidden' });
  if ($('#view-options-drop-down').css('visibility') === 'visible') {
    $('#view-options-drop-down').css({ visibility: 'hidden' });
  }
  $('#user-profile-drop-down-mn').css({ visibility: 'hidden' });
  $('#menu_arrow').css({ visibility: 'hidden' });
  $('#mn_menu_arrow').css({ visibility: 'hidden' });
  $('#language-arrow').removeClass('xgl-sort_up');
  $('#language-arrow').addClass('xgl-sort_down');
  if (!$('#all-service').data('clicked')) {
    $('#all_items_arrow').removeClass('xgl-sort_up');
    $('#all_items_arrow').addClass('xgl-sort_down');
  }
  $('#all-service').data('clicked', false);
});

$(document).ready(() => {
  /* Accessibility helpers so clearer focus ring can show with keyboard */

  // on document load
  document.body.classList.add('using-mouse');

  // Let the document know when the mouse is being used
  document.body.addEventListener('mousedown', () => {
    document.body.classList.add('using-mouse');
  });

  // Enable focus styling when Tab is pressed
  document.body.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      document.body.classList.remove('using-mouse');
    }
  });

  /**
   * Logic for enabing fixed nav bar
   */
  /*var top = $('#page-header .nav').position().top;
    var placeholder = $('<div id="header-placeholder">');
    var setFixed;*/

  bootbox.setDefaults({ locale: window.lang });
  /*placeholder.height($('#page-header').outerHeight() + 35).hide();
    $('.page-header').before(placeholder);
    setFixed = function() {
      if ($(window).scrollTop() > (top - 30)) {
        $('#page-header').addClass('fixed');
        $('#header-placeholder').show();
      } else {
        $('#page-header').removeClass('fixed');
        $('#header-placeholder').hide();
      }
    };
    $(window).scroll(setFixed);
    setFixed();*/

  $('#li-preferences').hover(() => {
    $('#menu_arrow').toggleClass('hovered');
  });

  $('#menu_arrow').hover(() => {
    $('#li-preferences').toggleClass('hovered');
  });

  $('#language-select').click(() => {
    if ($('#language-select').attr('aria-expanded') === 'false') {
      $('#language-arrow').removeClass('xgl-sort_down');
      $('#language-arrow').addClass('xgl-sort_up');
    } else {
      $('#language-arrow').removeClass('xgl-sort_up');
      $('#language-arrow').addClass('xgl-sort_down');
    }
  });

  $('#all-service').click(() => {
    $('#all-service').data('clicked', true);
    $('#all_items_arrow').toggleClass('xgl-sort_up');
    $('#all_items_arrow').toggleClass('xgl-sort_down');
  });

  $('#all-service').click(() => {
    if ($('#all-service-drop-down').css('visibility') === 'hidden') {
      $('#all-service-drop-down').css({
        visibility: 'visible',
        transform: 'translate3d(0px, -41px, 0px)',
      });
      $('#menu_arrow_all_items').css({ visibility: 'visible', opacity: 1 });
    } else {
      $('#all-service-drop-down').css({ visibility: 'hidden' });
      $('#menu_arrow_all_items').css({ visibility: 'hidden' });
    }
  });

  $('body').mouseup(() => {
    if ($('#all-service-drop-down').css('visibility') === 'visible') {
      $('#all-service-drop-down').css({ visibility: 'hidden' });
      $('#menu_arrow_all_items').css({ visibility: 'hidden' });
    }
  });
  $('.mn-nul-dropdown-toggle').click(() => {
    if ($('#user-profile-drop-down-mn').css('visibility') === 'hidden') {
      $('#mn_menu_arrow').css({ visibility: 'visible', opacity: 1 });
      $('#user-profile-drop-down-mn').css({ visibility: 'visible', opacity: 1 });
    } else {
      $('#user-profile-drop-down-mn').css({ visibility: 'hidden' });
      $('#mn_menu_arrow').css({ visibility: 'hidden' });
    }
  });
  $('.nul-dropdown-toggle').click(() => {
    if ($('#user-profile-drop-down').css('visibility') === 'hidden') {
      const box = document.getElementById('user_menu_box').offsetWidth;
      const box_arrow = document.getElementById('menu_arrow').offsetWidth;
      const menu_box = document.getElementById('user-profile-drop-down').offsetWidth;
      $('#menu_arrow').css({
        visibility: 'visible',
        opacity: 1,
        left: `${(box - box_arrow) / 2}px`,
      });
      $('#user-profile-drop-down').css({
        visibility: 'visible',
        opacity: 1,
        transform: `translate3d(${(box - menu_box) / 2}px, 47px, 0px)`,
        display: 'flex',
        'justify-content': 'center',
      });
    } else {
      $('#user-profile-drop-down').css({ visibility: 'hidden' });
      $('#menu_arrow').css({ visibility: 'hidden' });
    }
  });

  $('.nul-utility-btn').click(() => {
    if ($('#user-profile-drop-down-mn').css('visibility') === 'hidden') {
      $('#menu_arrow_mn').css({ visibility: 'visible', opacity: 1 });
      $('#user-profile-drop-down-mn').css({ visibility: 'visible', opacity: 1 });
    } else {
      $('#user-profile-drop-down-mn').css({ visibility: 'hidden' });
      $('#menu_arrow_mn').css({ visibility: 'hidden' });
    }
  });
  $('.mn-open-btn').click(() => {
    $('.mn-navbar-container').addClass('show');
  });

  $('.mn-close-btn').click(() => {
    $('.mn-navbar-container').removeClass('show');
  });

  $('.dn-menu')
    .children('li')
    .each(function () {
      if (!this.hasChildNodes()) {
        return;
      }
      if (
        this.firstElementChild
          .getAttribute('href')
          .indexOf(window.location.pathname.replace(/\//g, '')) >= 0
      ) {
        this.firstElementChild.className += ' selected active';
        this.firstElementChild.getElementsByTagName('span')[0].style.top = '2px';
      } else {
        this.firstElementChild.className = 'menu_bar';
        this.firstElementChild.getElementsByTagName('span')[0].style.top = '0px';
      }
    });

  $.ajaxSetup({
    dataType: 'json',
  });

  $(document).ajaxError((err, jqXHR) => {
    if (jqXHR.status === 401) {
      window.location = '/login';
    }
  });

  svg4everybody();
});
